import { render } from "./AvisoPrivacidade.vue?vue&type=template&id=d7e98d80&scoped=true"
import script from "./AvisoPrivacidade.vue?vue&type=script&lang=js"
export * from "./AvisoPrivacidade.vue?vue&type=script&lang=js"

import "./AvisoPrivacidade.vue?vue&type=style&index=0&id=d7e98d80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7e98d80"]])

export default __exports__